export class APIError {
	constructor(public status: number, public statusText: string, public error: any) {}
}

export const isAPIError = (error: any): error is APIError => {
	return error instanceof APIError
}
